// extracted by mini-css-extract-plugin
export default {"about":"About_about__iivJb","content":"About_content__hgJeq","img":"About_img__6Gy7L","info":"About_info__PxqGX"};